import { Global } from '@emotion/react';
import React from 'react';
import { GoogleHostedFonts } from './GoogleHostedFonts';
import { SelfHostedFonts } from './SelfHostedFonts';
export const DownloadFonts = _ref => {
  let {
    setFontDisplayToOptional,
    env
  } = _ref;
  const fontDisplay = setFontDisplayToOptional ? 'optional' : 'swap';
  return React.createElement(Global, {
    styles: GoogleHostedFonts(fontDisplay)
  });
};
export const DownloadSelfHostedFonts = _ref2 => {
  let {
    setFontDisplayToOptional,
    env
  } = _ref2;
  const fontDisplay = setFontDisplayToOptional ? 'optional' : 'swap';
  return React.createElement(Global, {
    styles: SelfHostedFonts(fontDisplay, env)
  });
};
//# sourceMappingURL=index.js.map